import React from 'react';
import {IStore} from "../../store/reducers";
import actionTypes from "../../store/actionTypes";
import {connect} from "react-redux";
import {Paper, Typography, Checkbox, InputLabel, Select, MenuItem, FormControl, Button} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import {SendRounded} from "@material-ui/icons";
import axios from "axios";
import config from "../../config.json";


interface IProps {
    idioma: string
    plan: number
    precio: number
    text: Record<string, string>
    changePlan(plan: number): void
    changePrecio(plan: number): void
    changeParcelas(parcelas: number): void
    changeSuperficie(superficie: number): void
    changeDuracion(duracion: number): void
}

interface IState {
    hover: string
    superficie: number
    codigoPromocional: string
    errorPromocion: boolean
    promociones: Record<string, string|number>[]
    promocionProps: Record<string, string|number>
    promocion: string
    superficies: Record<number, Record<number, (string|number|null)[]>>
}

class Planes extends React.Component<IProps, IState> {

    state: IState = {
        hover: "",
        superficie: 0,
        codigoPromocional: "",
        errorPromocion: false,
        promociones: [] as Record<string, string|number>[],
        promocionProps: {} as Record<string, string|number>,
        promocion: "",
        superficies: {
            1: {
                0: ["Hasta 20 Ha", 300, 20],
                1: ["21-50 Ha", 420, 50],
                2: ["51-100 Ha", 540, 100],
                3: ["101-200 Ha", 660, 200],
                4: ["Más de 200 ha", null]
            },
            2: {
                0: ["Hasta 20 Ha", 720, 20],
                1: ["21-50 Ha", 960, 50],
                2: ["51-100 Ha", 1200, 100],
                3: ["101-200 Ha", 1560, 200],
                4: ["Más de 200 ha", null]
            }
        }
    };

    componentDidMount() {

        if (this.props.idioma === "en") {
            this.setState({
                superficies: {
                    1: {
                        0: ["Up to 20 Ha", 300, 20],
                        1: ["21-50 Ha", 420, 50],
                        2: ["51-100 Ha", 540, 100],
                        3: ["101-200 Ha", 660, 200],
                        4: ["More than 200 ha", null]
                    },
                    2: {
                        0: ["Up to 20 Ha", 720, 20],
                        1: ["21-50 Ha", 960, 50],
                        2: ["51-100 Ha", 1200, 100],
                        3: ["101-200 Ha", 1560, 200],
                        4: ["More than ha", null]
                    }
                }
            })
        }

        axios.get(config.url+'/promociones')
            .then((res) => {
                this.setState({promociones: res.data})
            })

        this.props.changeDuracion(12)

        if (this.props.plan === 0) {
            this.props.changeSuperficie(200)
            this.props.changeParcelas(3)
        }

        if (this.props.plan === 1) {
            this.props.changePrecio(this.state.superficies[1][this.state.superficie][1] as number)
            this.props.changeSuperficie(this.state.superficies[1][this.state.superficie][2] as number)
            this.props.changeParcelas(10)
        }

        if (this.props.plan === 2) {
            this.props.changePrecio(this.state.superficies[2][this.state.superficie][1] as number)
            this.props.changeSuperficie(this.state.superficies[2][this.state.superficie][2] as number)
            this.props.changeParcelas(20)
        }

    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        if (nextState.promocion.length === 0) {
            if (this.state.superficie !== nextState.superficie && nextProps.plan !== 0) {
                this.props.changePrecio(this.state.superficies[nextProps.plan][nextState.superficie][1] as number)
            }

            if (this.props.plan !== nextProps.plan && nextProps.plan !== 0) {
                this.props.changePrecio(this.state.superficies[nextProps.plan][nextState.superficie][1] as number)
            }
        }

        return true
    }

    handlePromocion = () => {
        let encontrado = false
        for (let promocion of this.state.promociones) {
            const expiracion = new Date((promocion["fecha_expiracion"] as string).split("/").reverse().join('-'))
            if (new Date() > expiracion) continue
            if (this.state.codigoPromocional === promocion["codigo"]) {
                encontrado = true
                this.setState({
                    promocion: promocion["codigo"] as string,
                    promocionProps: promocion
                })
                this.props.changePrecio(promocion["precio"] as number)
                this.props.changeParcelas(promocion["parcelas"] as number)
                this.props.changeSuperficie(promocion["superficie"] as number)
                this.props.changeDuracion(promocion["duracion"] as number)
                this.props.changePlan(promocion["tipo_usuario"] as number)
            }

        }
        if (! encontrado) this.setState({errorPromocion: true})
    }

    render() {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    width: '100%'
                }}
            >

                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        height: 100,
                        alignItems: "center",
                        justifyContent: "space-around",
                        width: '100%)',
                    }}
                >

                    {this.props.plan !== 0 && this.state.promocion.length === 0?
                        <FormControl
                            style={{
                                width: 250
                            }}
                        >
                            <InputLabel style={{fontSize: 16, fontFamily: "Poppins"}}>Superficie a
                                contratar:</InputLabel>
                            <Select
                                style={{width: '100%', fontSize: 18, fontFamily: "Poppins"}}
                                value={this.state.superficie}
                                onChange={e => {
                                    this.setState({superficie: e.target.value as number})
                                }}
                            >
                                {Object.keys(this.state.superficies[this.props.plan]).map(superficie =>
                                    <MenuItem
                                        key={superficie}
                                        value={superficie}
                                        disabled={this.state.superficies[this.props.plan][parseInt(superficie)][1] === null}
                                    >
                                        {this.state.superficies[this.props.plan][parseInt(superficie)][1] !== null ?
                                            `${this.state.superficies[this.props.plan][parseInt(superficie)][0]}  ${this.state.superficies[this.props.plan][parseInt(superficie)][1]} €`
                                            :
                                            `${this.state.superficies[this.props.plan][parseInt(superficie)][0]}, ${this.props.text["37"]}`
                                        }
                                    </MenuItem>
                                )}
                            </Select>
                        </FormControl>
                        :
                        this.state.promocion.length !== 0?
                            <Button
                                style={{
                                    textTransform: "none",
                                    height: 64,
                                    marginTop: -5
                                }}
                                variant={"outlined"}
                                onClick={() => {
                                    this.setState({
                                        promocion: "",
                                        promocionProps: {} as Record<string, string|number>
                                    })
                                }}
                            >
                                <Typography
                                    style={{
                                        marginBottom: -5,
                                        fontSize: 16,
                                        fontFamily: "Poppins"
                                    }}
                                >
                                    {this.props.text["38"]}
                                </Typography>
                            </Button>
                            :
                            <div/>
                    }

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "fit-content",
                            height: "fit-content"
                        }}
                    >
                        <TextField
                            style={{
                                width: 250,
                                fontFamily: "Poppins"
                            }}
                            variant={"outlined"}
                            inputProps={{style: {fontSize: 18, fontFamily: "Poppins"}}}
                            InputLabelProps={{style: {fontSize: 16, fontFamily: "Poppins"}}}
                            value={this.state.codigoPromocional}
                            onChange={e => {
                                this.setState({
                                    codigoPromocional: e.target.value,
                                    errorPromocion: false
                                })
                            }}
                            label={this.state.errorPromocion?
                                this.props.text["39"]
                                :
                                this.props.text["40"]
                            }
                            error={this.state.errorPromocion}
                        />

                        <Button
                            variant={"outlined"}
                            style={{
                                width: 50,
                                height: 64,
                                marginTop: -5
                            }}
                            onClick={() => this.handlePromocion()}
                        >
                            <SendRounded
                                style={{
                                    width: 40,
                                    height: 40
                                }}
                            />
                        </Button>

                    </div>

                </div>

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: "space-around",
                        height: 'calc(100% - 100px)',
                        width: '100%'
                    }}
                >

                    {this.state.promocion.length === 0 &&
                        <Paper
                            elevation={this.state.hover === "basico" ? 5 : 2}
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "30%",
                                height: "100%",
                                alignItems: "center",
                                cursor: "pointer",
                                borderStyle: "solid",
                                borderWidth: 4,
                                borderColor: this.props.plan === 0 ? "#80ED99" : "#fff",
                                borderRadius: 20
                            }}
                            onMouseEnter={() => this.setState({hover: 'basico'})}
                            onMouseLeave={() => this.setState({hover: ''})}
                            onClick={() => {
                                this.props.changePlan(0)
                                this.props.changeParcelas(3)
                                this.props.changeSuperficie(200)
                                this.props.changeDuracion(12)
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: 'calc(100% - 40px)',
                                    height: "100%"
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "100%",
                                        height: 60
                                    }}
                                >
                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            fontSize: 24,
                                            fontFamily: "Poppins"
                                        }}
                                    >
                                        {this.props.text["41"]}
                                    </Typography>
                                </div>


                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "100%",
                                        height: 90
                                    }}
                                >
                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            color: "#4C494B",
                                            fontSize: 14,
                                            fontFamily: "Poppins"
                                        }}
                                    >
                                        {this.props.text["42"]}
                                    </Typography>
                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: 'calc(100% + 40px)',
                                        height: 80,
                                        marginLeft: -20,
                                        backgroundColor: '#C7F9CC'
                                    }}
                                >
                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            fontSize: 24,
                                            fontWeight: "bold",
                                            fontFamily: "Poppins"
                                        }}
                                    >
                                        {this.props.text["43"]}
                                    </Typography>
                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        width: "100%",
                                        height: 'calc(100% - 60px - 90px - 80px - 20px)',
                                        marginTop: 10,
                                        overflowY: "auto"
                                    }}
                                >
                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            color: "#4C494B",
                                            fontSize: 14,
                                            fontFamily: "Poppins",
                                            marginBottom: 10
                                        }}
                                    >
                                        {"3 " + this.props.text["44"]}
                                    </Typography>

                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            color: "#4C494B",
                                            fontSize: 14,
                                            fontFamily: "Poppins",
                                            marginBottom: 10
                                        }}
                                    >
                                        {this.props.text["45"]}
                                    </Typography>

                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            color: "#4C494B",
                                            fontSize: 14,
                                            fontFamily: "Poppins",
                                            marginBottom: 10
                                        }}
                                    >
                                        {this.props.text["46"]}
                                    </Typography>

                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            color: "#4C494B",
                                            fontSize: 14,
                                            fontFamily: "Poppins",
                                            marginBottom: 10
                                        }}
                                    >
                                        {this.props.text["47"]}
                                    </Typography>
                                </div>
                            </div>
                        </Paper>
                    }


                    {this.state.promocion.length === 0 &&
                        <Paper
                            elevation={this.state.hover === "avanzado" ? 5 : 2}
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "30%",
                                height: "100%",
                                alignItems: "center",
                                cursor: "pointer",
                                borderStyle: "solid",
                                borderWidth: 4,
                                borderColor: this.props.plan === 1 ? "#80ED99" : "#fff",
                                borderRadius: 20
                            }}
                            onMouseEnter={() => this.setState({hover: 'avanzado'})}
                            onMouseLeave={() => this.setState({hover: ''})}
                            onClick={() => {
                                this.props.changePlan(1)
                                this.props.changeParcelas(10)
                                this.props.changeDuracion(12)
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: 'calc(100% - 40px)',
                                    height: "100%"
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "100%",
                                        height: 60
                                    }}
                                >
                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            fontSize: 24,
                                            fontFamily: "Poppins"
                                        }}
                                    >
                                        {this.props.text["48"]}
                                    </Typography>
                                </div>


                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "100%",
                                        height: 90
                                    }}
                                >
                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            color: "#4C494B",
                                            fontSize: 14,
                                            fontFamily: "Poppins"
                                        }}
                                    >
                                        {this.props.text["49"]}
                                    </Typography>
                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: 'calc(100% + 40px)',
                                        height: 80,
                                        marginLeft: -20,
                                        backgroundColor: '#C7F9CC'
                                    }}
                                >
                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            fontSize: 24,
                                            fontWeight: "bold",
                                            fontFamily: "Poppins"
                                        }}
                                    >
                                        {`${this.state.superficies[1][this.state.superficie][1]}` + " €/"+this.props.text["50"]}
                                    </Typography>
                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            fontSize: 12,
                                            fontFamily: "Poppins"
                                        }}
                                    >
                                        {this.props.text["51"]}
                                    </Typography>
                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        width: "100%",
                                        height: 'calc(100% - 60px - 90px - 80px - 20px)',
                                        marginTop: 10,
                                        overflowY: "auto"
                                    }}
                                >
                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            color: "#4C494B",
                                            fontSize: 14,
                                            fontFamily: "Poppins",
                                            marginBottom: 10
                                        }}
                                    >
                                        {this.props.text["52"]}
                                    </Typography>

                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            color: "#4C494B",
                                            fontSize: 14,
                                            fontFamily: "Poppins",
                                            marginBottom: 10
                                        }}
                                    >
                                        {"10 " + this.props.text["44"]}
                                    </Typography>

                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            color: "#4C494B",
                                            fontSize: 14,
                                            fontFamily: "Poppins",
                                            marginBottom: 10
                                        }}
                                    >
                                        {this.props.text["53"]}
                                    </Typography>

                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            color: "#4C494B",
                                            fontSize: 14,
                                            fontFamily: "Poppins",
                                            marginBottom: 10
                                        }}
                                    >
                                        {this.props.text["54"]}
                                    </Typography>

                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            color: "#4C494B",
                                            fontSize: 14,
                                            fontFamily: "Poppins",
                                            marginBottom: 10
                                        }}
                                    >
                                        {this.props.text["55"]}
                                    </Typography>

                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            color: "#4C494B",
                                            fontSize: 14,
                                            fontFamily: "Poppins",
                                            marginBottom: 10
                                        }}
                                    >
                                        {this.props.text["56"]}
                                    </Typography>

                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            color: "#4C494B",
                                            fontSize: 14,
                                            fontFamily: "Poppins",
                                            marginBottom: 10
                                        }}
                                    >
                                        {this.props.text["57"]}
                                    </Typography>
                                </div>
                            </div>
                        </Paper>
                    }


                    {this.state.promocion.length === 0 &&
                        <Paper
                            elevation={this.state.hover === "profesional" ? 5 : 2}
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "30%",
                                height: "100%",
                                alignItems: "center",
                                cursor: "pointer",
                                borderStyle: "solid",
                                borderWidth: 4,
                                borderColor: this.props.plan === 2 ? "#80ED99" : "#fff",
                                borderRadius: 20
                            }}
                            onMouseEnter={() => this.setState({hover: 'profesional'})}
                            onMouseLeave={() => this.setState({hover: ''})}
                            onClick={() => {
                                this.props.changePlan(2)
                                this.props.changeParcelas(20)
                                this.props.changeDuracion(12)
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: 'calc(100% - 40px)',
                                    height: "100%"
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "100%",
                                        height: 60
                                    }}
                                >
                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            fontSize: 24,
                                            fontFamily: "Poppins"
                                        }}
                                    >
                                        {this.props.text["58"]}
                                    </Typography>
                                </div>


                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "100%",
                                        height: 90
                                    }}
                                >
                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            color: "#4C494B",
                                            fontSize: 14,
                                            fontFamily: "Poppins"
                                        }}
                                    >
                                        {this.props.text["59"]}
                                    </Typography>
                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: 'calc(100% + 40px)',
                                        height: 80,
                                        marginLeft: -20,
                                        backgroundColor: '#C7F9CC'
                                    }}
                                >
                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            fontSize: 24,
                                            fontWeight: "bold",
                                            fontFamily: "Poppins"
                                        }}
                                    >
                                        {`${this.state.superficies[2][this.state.superficie][1]}` + " €/"+this.props.text["50"]}
                                    </Typography>
                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            fontSize: 12,
                                            fontFamily: "Poppins"
                                        }}
                                    >
                                        {this.props.text["51"]}
                                    </Typography>
                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        width: "100%",
                                        height: 'calc(100% - 60px - 90px - 80px - 20px)',
                                        marginTop: 10,
                                        overflowY: "auto"
                                    }}
                                >
                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            color: "#4C494B",
                                            fontSize: 14,
                                            fontFamily: "Poppins",
                                            marginBottom: 10
                                        }}
                                    >
                                        {this.props.text["60"]}
                                    </Typography>

                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            color: "#4C494B",
                                            fontSize: 14,
                                            fontFamily: "Poppins",
                                            marginBottom: 10
                                        }}
                                    >
                                        {"20 " + this.props.text["44"]}
                                    </Typography>

                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            color: "#4C494B",
                                            fontSize: 14,
                                            fontFamily: "Poppins",
                                            marginBottom: 10
                                        }}
                                    >
                                        {this.props.text["61"]}
                                    </Typography>

                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            color: "#4C494B",
                                            fontSize: 14,
                                            fontFamily: "Poppins",
                                            marginBottom: 10
                                        }}
                                    >
                                        {this.props.text["62"]}
                                    </Typography>

                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            color: "#4C494B",
                                            fontSize: 14,
                                            fontFamily: "Poppins",
                                            marginBottom: 10
                                        }}
                                    >
                                        {this.props.text["63"]}
                                    </Typography>

                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            color: "#4C494B",
                                            fontSize: 14,
                                            fontFamily: "Poppins",
                                            marginBottom: 10
                                        }}
                                    >
                                        {this.props.text["64"]}
                                    </Typography>

                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            color: "#4C494B",
                                            fontSize: 14,
                                            fontFamily: "Poppins",
                                            marginBottom: 10
                                        }}
                                    >
                                        {this.props.text["65"]}
                                    </Typography>
                                </div>
                            </div>
                        </Paper>
                    }


                    {this.state.promocion.length !== 0 &&
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: "30%",
                                height: "100%"
                            }}
                        >
                            <Paper
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100%",
                                    height: "100%",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    borderStyle: "solid",
                                    borderWidth: 4,
                                    borderColor: "#fff",
                                    borderRadius: 20
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        width: 'calc(100% - 40px)',
                                        height: "100%"
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "100%",
                                            height: 60
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                fontSize: 24,
                                                fontFamily: "Poppins"
                                            }}
                                        >
                                            {this.props.text["41"]}
                                        </Typography>
                                    </div>


                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "100%",
                                            height: 90
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                color: "#4C494B",
                                                fontSize: 14,
                                                fontFamily: "Poppins"
                                            }}
                                        >
                                            {this.props.text["42"]}
                                        </Typography>
                                    </div>

                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: 'calc(100% + 40px)',
                                            height: 80,
                                            marginLeft: -20,
                                            backgroundColor: '#C7F9CC'
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                fontSize: 24,
                                                fontWeight: "bold",
                                                fontFamily: "Poppins"
                                            }}
                                        >
                                            {this.props.text["43"]}
                                        </Typography>
                                    </div>

                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            width: "100%",
                                            height: 'calc(100% - 60px - 90px - 80px - 20px)',
                                            marginTop: 10,
                                            overflowY: "auto"
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                color: "#4C494B",
                                                fontSize: 14,
                                                fontFamily: "Poppins",
                                                marginBottom: 10
                                            }}
                                        >
                                            {"3 " + this.props.text["44"]}
                                        </Typography>

                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                color: "#4C494B",
                                                fontSize: 14,
                                                fontFamily: "Poppins",
                                                marginBottom: 10
                                            }}
                                        >
                                            {this.props.text["45"]}
                                        </Typography>

                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                color: "#4C494B",
                                                fontSize: 14,
                                                fontFamily: "Poppins",
                                                marginBottom: 10
                                            }}
                                        >
                                            {this.props.text["46"]}
                                        </Typography>

                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                color: "#4C494B",
                                                fontSize: 14,
                                                fontFamily: "Poppins",
                                                marginBottom: 10
                                            }}
                                        >
                                            {this.props.text["47"]}
                                        </Typography>
                                    </div>
                                </div>
                            </Paper>

                            <Paper
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100%",
                                    height: "100%",
                                    marginLeft: "-100%",
                                    alignItems: "center",
                                    borderRadius: 20,
                                    zIndex: 200,
                                    backgroundColor: "rgba(255,255,255,0.7)"
                                }}
                            />

                        </div>
                    }


                    {this.state.promociones.length !== 0 && this.state.promocionProps["tipo_usuario"] === 2 &&
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: "30%",
                                height: "100%"
                            }}
                        >
                            <Paper
                                elevation={this.state.hover === "avanzado" ? 5 : 2}
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100%",
                                    height: "100%",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    borderStyle: "solid",
                                    borderWidth: 4,
                                    borderColor: this.props.plan === 1 ? "#80ED99" : "#fff",
                                    borderRadius: 20
                                }}
                                onMouseEnter={() => this.setState({hover: 'avanzado'})}
                                onMouseLeave={() => this.setState({hover: ''})}
                                onClick={() => {
                                    this.props.changePlan(1)
                                    this.props.changeParcelas(10)
                                    this.props.changeDuracion(12)
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        width: 'calc(100% - 40px)',
                                        height: "100%"
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "100%",
                                            height: 60
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                fontSize: 24,
                                                fontFamily: "Poppins"
                                            }}
                                        >
                                            {this.props.text["48"]}
                                        </Typography>
                                    </div>


                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "100%",
                                            height: 90
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                color: "#4C494B",
                                                fontSize: 14,
                                                fontFamily: "Poppins"
                                            }}
                                        >
                                            {this.props.text["49"]}
                                        </Typography>
                                    </div>

                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: 'calc(100% + 40px)',
                                            height: 80,
                                            marginLeft: -20,
                                            backgroundColor: '#C7F9CC'
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                fontSize: 24,
                                                fontWeight: "bold",
                                                fontFamily: "Poppins"
                                            }}
                                        >
                                            {`${this.state.superficies[1][this.state.superficie][1]}` + " €/"+this.props.text["50"]}
                                        </Typography>
                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                fontSize: 12,
                                                fontFamily: "Poppins"
                                            }}
                                        >
                                            {this.props.text["51"]}
                                        </Typography>
                                    </div>

                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            width: "100%",
                                            height: 'calc(100% - 60px - 90px - 80px - 20px)',
                                            marginTop: 10,
                                            overflowY: "auto"
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                color: "#4C494B",
                                                fontSize: 14,
                                                fontFamily: "Poppins",
                                                marginBottom: 10
                                            }}
                                        >
                                            {this.props.text["52"]}
                                        </Typography>

                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                color: "#4C494B",
                                                fontSize: 14,
                                                fontFamily: "Poppins",
                                                marginBottom: 10
                                            }}
                                        >
                                            {"10 " + this.props.text["44"]}
                                        </Typography>

                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                color: "#4C494B",
                                                fontSize: 14,
                                                fontFamily: "Poppins",
                                                marginBottom: 10
                                            }}
                                        >
                                            {this.props.text["53"]}
                                        </Typography>

                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                color: "#4C494B",
                                                fontSize: 14,
                                                fontFamily: "Poppins",
                                                marginBottom: 10
                                            }}
                                        >
                                            {this.props.text["54"]}
                                        </Typography>

                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                color: "#4C494B",
                                                fontSize: 14,
                                                fontFamily: "Poppins",
                                                marginBottom: 10
                                            }}
                                        >
                                            {this.props.text["55"]}
                                        </Typography>

                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                color: "#4C494B",
                                                fontSize: 14,
                                                fontFamily: "Poppins",
                                                marginBottom: 10
                                            }}
                                        >
                                            {this.props.text["56"]}
                                        </Typography>

                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                color: "#4C494B",
                                                fontSize: 14,
                                                fontFamily: "Poppins",
                                                marginBottom: 10
                                            }}
                                        >
                                            {this.props.text["57"]}
                                        </Typography>
                                    </div>
                                </div>
                            </Paper>

                            <Paper
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100%",
                                    height: "100%",
                                    marginLeft: "-100%",
                                    alignItems: "center",
                                    borderRadius: 20,
                                    zIndex: 200,
                                    backgroundColor: "rgba(255,255,255,0.7)"
                                }}
                            />

                        </div>
                    }




                    {this.state.promocion.length !== 0 &&
                        <Paper
                            elevation={5}
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "30%",
                                height: "100%",
                                alignItems: "center",
                                cursor: "pointer",
                                borderStyle: "solid",
                                borderWidth: 4,
                                borderColor: "#80ED99",
                                borderRadius: 20
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "flex-end",
                                    justifyContent: "flex-end",
                                    width: "100%",
                                    height: 20,
                                    marginTop: -20
                                }}
                            >
                                <Paper
                                    style={{
                                        height: "fit-content",
                                        backgroundColor: "#b6243b",
                                        marginBottom: -15,
                                        marginRight: -10
                                    }}
                                >
                                    <Typography
                                        style={{
                                            color: "white",
                                            fontSize: 12,
                                            fontWeight: "bold",
                                            fontFamily: "Poppins",
                                            margin: 5
                                        }}
                                    >
                                        {this.props.text["66"]}
                                    </Typography>
                                </Paper>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: 'calc(100% - 40px)',
                                    height: "100%"
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "100%",
                                        height: 60
                                    }}
                                >
                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            fontSize: 24,
                                            fontFamily: "Poppins"
                                        }}
                                    >
                                        {this.state.promocionProps["tipo_usuario"] === 1 &&
                                            this.props.text["48"]
                                        }
                                        {this.state.promocionProps["tipo_usuario"] === 2 &&
                                            this.props.text["58"]
                                        }
                                    </Typography>
                                </div>


                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "100%",
                                        height: 90
                                    }}
                                >
                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            color: "#4C494B",
                                            fontSize: 14,
                                            fontFamily: "Poppins"
                                        }}
                                    >
                                        ¡{this.props.text["67"]} {this.state.promocionProps["fecha_expiracion"]}!
                                    </Typography>
                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: 'calc(100% + 40px)',
                                        height: 80,
                                        marginLeft: -20,
                                        backgroundColor: '#C7F9CC'
                                    }}
                                >
                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            fontSize: 24,
                                            fontWeight: "bold",
                                            fontFamily: "Poppins"
                                        }}
                                    >
                                        {`${this.state.promocionProps["precio"]}` + ` €/${this.state.promocionProps["duracion"]} ${this.props.text["68"]}`}
                                    </Typography>
                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            fontSize: 12,
                                            fontFamily: "Poppins"
                                        }}
                                    >
                                        {this.props.text["51"]}
                                    </Typography>
                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        width: "100%",
                                        height: 'calc(100% - 60px - 90px - 80px - 20px)',
                                        marginTop: 10,
                                        overflowY: "auto"
                                    }}
                                >
                                    <Typography
                                        style={{
                                            textAlign: "center",
                                            color: "#4C494B",
                                            fontSize: 14,
                                            fontFamily: "Poppins",
                                            marginBottom: 10
                                        }}
                                    >
                                        {this.state.promocionProps["tipo_usuario"] === 1 &&
                                            `${this.props.text["69"]} ${this.state.promocionProps["parcelas"]}, ${this.props.text["70"]} ${this.state.promocionProps["superficie"]} Ha ${this.props.text["71"]} ${this.state.promocionProps["duracion"]} ${this.props.text["68"]}`
                                        }
                                        {this.state.promocionProps["tipo_usuario"] === 2 &&
                                            `${this.props.text["72"]} ${this.state.promocionProps["parcelas"]}, ${this.props.text["70"]} ${this.state.promocionProps["superficie"]} Ha ${this.props.text["71"]} ${this.state.promocionProps["duracion"]} ${this.props.text["68"]}`
                                        }
                                    </Typography>
                                </div>
                            </div>
                        </Paper>
                    }


                    {this.state.promociones.length !== 0 && this.state.promocionProps["tipo_usuario"] === 1 &&
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                width: "30%",
                                height: "100%"
                            }}
                        >
                            <Paper
                                elevation={2}
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100%",
                                    height: "100%",
                                    alignItems: "center",
                                    borderStyle: "solid",
                                    borderWidth: 4,
                                    borderColor: "#fff",
                                    borderRadius: 20
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        width: 'calc(100% - 40px)',
                                        height: "100%"
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "100%",
                                            height: 60
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                fontSize: 24,
                                                fontFamily: "Poppins"
                                            }}
                                        >
                                            {this.props.text["58"]}
                                        </Typography>
                                    </div>


                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "100%",
                                            height: 90
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                color: "#4C494B",
                                                fontSize: 14,
                                                fontFamily: "Poppins"
                                            }}
                                        >
                                            {this.props.text["59"]}
                                        </Typography>
                                    </div>

                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: 'calc(100% + 40px)',
                                            height: 80,
                                            marginLeft: -20,
                                            backgroundColor: '#C7F9CC'
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                fontSize: 24,
                                                fontWeight: "bold",
                                                fontFamily: "Poppins"
                                            }}
                                        >
                                            {`${this.state.superficies[2][this.state.superficie][1]}` + " €/"+this.props.text["50"]}
                                        </Typography>
                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                fontSize: 12,
                                                fontFamily: "Poppins"
                                            }}
                                        >
                                            {this.props.text["51"]}
                                        </Typography>
                                    </div>

                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            width: "100%",
                                            height: 'calc(100% - 60px - 90px - 80px - 20px)',
                                            marginTop: 10,
                                            overflowY: "auto"
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                color: "#4C494B",
                                                fontSize: 14,
                                                fontFamily: "Poppins",
                                                marginBottom: 10
                                            }}
                                        >
                                            {this.props.text["60"]}
                                        </Typography>

                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                color: "#4C494B",
                                                fontSize: 14,
                                                fontFamily: "Poppins",
                                                marginBottom: 10
                                            }}
                                        >
                                            {"20 " + this.props.text["44"]}
                                        </Typography>

                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                color: "#4C494B",
                                                fontSize: 14,
                                                fontFamily: "Poppins",
                                                marginBottom: 10
                                            }}
                                        >
                                            {this.props.text["61"]}
                                        </Typography>

                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                color: "#4C494B",
                                                fontSize: 14,
                                                fontFamily: "Poppins",
                                                marginBottom: 10
                                            }}
                                        >
                                            {this.props.text["62"]}
                                        </Typography>

                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                color: "#4C494B",
                                                fontSize: 14,
                                                fontFamily: "Poppins",
                                                marginBottom: 10
                                            }}
                                        >
                                            {this.props.text["63"]}
                                        </Typography>

                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                color: "#4C494B",
                                                fontSize: 14,
                                                fontFamily: "Poppins",
                                                marginBottom: 10
                                            }}
                                        >
                                            {this.props.text["64"]}
                                        </Typography>

                                        <Typography
                                            style={{
                                                textAlign: "center",
                                                color: "#4C494B",
                                                fontSize: 14,
                                                fontFamily: "Poppins",
                                                marginBottom: 10
                                            }}
                                        >
                                            {this.props.text["65"]}
                                        </Typography>
                                    </div>
                                </div>
                            </Paper>

                            <Paper
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100%",
                                    height: "100%",
                                    marginLeft: "-100%",
                                    alignItems: "center",
                                    borderRadius: 20,
                                    zIndex: 200,
                                    backgroundColor: "rgba(255,255,255,0.7)"
                                }}
                            />

                        </div>
                    }


                </div>

            </div>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Planes);
